/**
 * Created by jszh on 2020/6/12.
 */


'use strict';
let addressList = []; //地址列表

import { pcassCode } from '../lib/pcasCode';

addressList = pcassCode;
addressList.forEach(item => {
    formatAddresList(item, 1, '')
})

/**
 * 地址数据处理
 * @param addressList-各级数据对象
 * @param index-对应的省/市/县区/街道
 * @param province-只有直辖市会处理为  北京市北京市
 * @returns <array>
 */
function formatAddresList(addressList, index, province) {
    if (index === 1) { //省
        addressList.province = addressList.text;
    }
    if (index === 2) { //市
        addressList.city = addressList.text;
    }
    if (index === 3) { //区或者县
        addressList.county = addressList.text;
    }
    if (addressList.children) {
        index++;
        addressList.children.forEach(res => {
            formatAddresList(res, index, addressList)
        })
    }
}


/**
 * 解析邮编
 * @param
 * @returns <array>
 */
function zipCodeFormat(zipCode) {
    let list = []
    zipCode.forEach((el) => {
        if (el.child) {
            el.child.forEach((event) => {
                if (event.child) {
                    event.child.forEach(element => {
                        list.push(element.zipcode)
                    })
                }

            })
        }
    })
    return list;
}


var smartObj = {}
    /**
     * 解析邮编
     * @param event识别的地址
     * @returns <obj>
     */
function smart(event) {

    var hasprovince = '';
    var hascity = '';
    var hascounty = '';
    var residueaddress = '';

    event = stripscript(event); //过滤特殊字符
    let obj = {};
    let copyaddress = JSON.parse(JSON.stringify(event))
    copyaddress = copyaddress.split(' ');

    copyaddress.forEach((res, index) => {
        if (res) {
            if (res.length == 1) {
                res += 'XX'; // 过滤掉一位的名字或者地址
            }
            let addressObj = smatrAddress(res, obj, 1)

            residueaddress += ' ' + addressObj.residueaddress;
            obj = Object.assign(obj, addressObj)

            if (JSON.stringify(addressObj) === '{}') {
                obj.name = res.replace('XX', '');
            }
        }
    })

    if (residueaddress) {
        let baknamewait = '';
        let newaddress = '';
        newaddress = residueaddress.split(' ');

        newaddress.forEach((res, index) => {
            if (res) {
                if (!obj.province || !obj.city || !obj.county) {
                    let addressObjNew = smatrAddress(res, obj, 2)
                    residueaddress += ' ' + addressObjNew.residueaddress;
                    obj = Object.assign(obj, addressObjNew)
                }
                let realname = '';
                realname = checkRealname(res);
                if (realname) {
                    obj.name = realname;
                    residueaddress = residueaddress.replace(realname, '')
                } else {
                    if (baknamewait == '') {
                        baknamewait = res;
                    }
                    if (res.length < baknamewait.length) {
                        baknamewait = res;
                    }
                }
                obj.bakname = baknamewait;
            }
        });
        obj.address = stripscript(residueaddress);
    }


    return obj;
}

function smatrAddress(event, obj, nums) {
    smartObj = {};
    let address = event;
    address = stripscript(address); //过滤特殊字符

    //电话匹配
    const mobileReg = /(86-[1][0-9]{10})|(86[1][0-9]{10})|([1][0-9]{10})/g;
    const mobile = mobileReg.exec(address);
    if (mobile) {
        smartObj.mobile = mobile[0];
        address = address.replace(mobile[0], ' ')
    }
    //电话
    const phoneReg = /(([0-9]{3,4}-)[0-9]{7,8})|([0-9]{12})|([0-9]{11})|([0-9]{10})|([0-9]{9})|([0-9]{8})|([0-9]{7})/g;
    const phone = phoneReg.exec(address);
    if (phone) {
        smartObj.phone = phone[0];
        address = address.replace(phone[0], ' ')
    }

    if (obj.province) {
        address = address.replace(obj.province, '');
    }

    if (obj.city) {
        address = address.replace(obj.city, '');
    }

    if (obj.county) {
        address = address.replace(obj.county, '');
    }

    let matchAddress = ''
        //省匹配 比如输入北京市朝阳区，会用北  北京  北京市 北京市朝 以此类推在addressList里的province中做匹配，会得到北京市  河北省 天津市等等；
    let matchProvince = []; //粗略匹配上的省份   11
    matchAddress = '';

    for (let endIndex = 0; endIndex < address.length; endIndex++) {
        matchAddress = address.slice(0, endIndex + 2)

        addressList.forEach(res => {
            if (res['province'].indexOf(matchAddress) != -1) {
                matchProvince.push({
                    province: res.province,
                    provinceCode: res.value,
                    matchValue: matchAddress
                })
            }
        })
    }

    //统计筛选初略统计出的省份
    matchProvince.forEach(res => {
        res.index = 0;
        matchProvince.forEach(el => {
            if (res.province == el.province) {
                el.index++;
                if (res.matchValue.length > el.matchValue.length) {
                    el.matchValue = res.matchValue;
                }
            }
        })
    })

    if (matchProvince.length != 0) {
        if (obj.province) {
            address = address.replace(obj.province, '');
            address = address.replace('省', '');
            if (smartObj.province == '北京' || smartObj.province == '天津' || smartObj.province == '上海' || smartObj.province == '重庆') {
                address = address.replace('市', '');
            }
        } else {
            let province = matchProvince.reduce((p, v) => p.index < v.index ? v : p)
            smartObj.province = province.province;
            smartObj.provinceCode = province.provinceCode;
            address = address.replace(province.matchValue, '');
            address = address.replace('省', '');
            if (smartObj.province == '北京' || smartObj.province == '天津' || smartObj.province == '上海' || smartObj.province == '重庆') {
                address = address.replace('市', '');
            }
        }

    }

    //市查找
    let matchCity = []; //粗略匹配上的市 
    matchAddress = '';
    for (let endIndex = 0; endIndex < address.length; endIndex++) {
        matchAddress = address.slice(0, endIndex + 2)
        addressList.forEach(el => {
            //  if (el.name == smartObj.province) {
            if (smartObj.province == '北京' || smartObj.province == '天津' || smartObj.province == '上海' || smartObj.province == '重庆') {
                el.children.forEach(item => {
                    item.children.forEach(res => {
                        if (res['county'].indexOf(matchAddress) != -1) {
                            matchCity.push({
                                county: res.county,
                                countyCode: res.value,
                                city: item.city,
                                cityCode: item.value,
                                matchValue: matchAddress,
                                province: el.province,
                                provinceCode: el.value,
                            })
                        }
                    })
                })
            } else {
                el.children.forEach(res => {
                    if (res['city'].indexOf(matchAddress) != -1) {
                        matchCity.push({
                            city: res.city,
                            cityCode: res.value,
                            matchValue: matchAddress,
                            province: el.province,
                            provinceCode: el.value,
                        })
                    }
                })
            }
            // }
        })

    }

    //统计筛选初略统计出的市
    matchCity.forEach(res => {
        res.index = 0;
        matchCity.forEach(el => {
            if (res.city == el.city) {
                el.index++;
                if (res.matchValue.length > el.matchValue.length) {
                    el.matchValue = res.matchValue;
                }
            }
        })
    })

    if (matchCity.length != 0) {

        if (obj.province || smartObj.province) {

            matchCity.forEach(city => {
                if (city.province == obj.province || city.province == smartObj.province) {
                    smartObj.city = city.city
                    smartObj.cityCode = city.cityCode
                    smartObj.county = city.county
                    smartObj.countyCode = city.countyCode

                    address = address.replace(city.matchValue, '')
                    address = address.replace('市', '');
                }
            })

        } else {
            let city = matchCity.reduce((p, v) => p.index < v.index ? v : p)
            smartObj.city = city.city
            smartObj.cityCode = city.cityCode
            smartObj.county = city.county
            smartObj.countyCode = city.countyCode
            smartObj.province = city.province
            smartObj.provinceCode = city.provinceCode

            address = address.replace(city.matchValue, '')
            address = address.replace('市', '');
        }

    }

    //区县查找
    let matchCounty = []; //粗略匹配上的区县
    matchAddress = '';
    for (let endIndex = 0; endIndex < address.length; endIndex++) {
        matchAddress = address.slice(0, endIndex + 2)
        addressList.forEach(el => {
            //  if (el.name == smartObj.province) {
            if (smartObj.province == '北京' || smartObj.province == '天津' || smartObj.province == '上海' || smartObj.province == '重庆') {
                //nothing
            } else {
                el.children.forEach(item => {
                    //  if (item.name == smartObj.city) {
                    item.children.forEach(res => {
                            if (res['county'].indexOf(matchAddress) != -1) {
                                matchCounty.push({
                                    county: res.county,
                                    countyCode: res.value,
                                    city: item.city,
                                    cityCode: item.value,
                                    matchValue: matchAddress,
                                    province: el.province,
                                    provinceCode: el.value,
                                })
                            }
                        })
                        //  }
                })
            }
            //  }
        })

    }

    //统计筛选初略统计出的区县
    matchCounty.forEach(res => {
        matchCounty.forEach(el => {
            if (res.city == el.city) {

                el.index++;
                if (res.matchValue.length > el.matchValue.length) {
                    el.matchValue = res.matchValue;
                }
            }
        })
    })

    if (matchCounty.length != 0) {
        if (obj.city || smartObj.city) {
            matchCounty.forEach(countys => {
                if (countys.city == obj.city || countys.city == smartObj.city) {
                    smartObj.county = countys.county
                    smartObj.countyCode = countys.countyCode

                    address = address.replace(countys.matchValue, '')
                    address = address.replace('市', '');
                }
            })

        } else {
            if (obj.province || smartObj.province) {
                matchCounty.forEach(countys => {
                    if (countys.province == obj.province || countys.province == smartObj.province) {
                        smartObj.city = countys.city
                        smartObj.cityCode = countys.cityCode
                        smartObj.county = countys.county
                        smartObj.countyCode = countys.countyCode

                        address = address.replace(countys.matchValue, '')
                        address = address.replace('市', '');
                    }
                })
            } else {
                let city = matchCity.reduce((p, v) => p.index < v.index ? v : p)
                smartObj.city = city.city
                smartObj.cityCode = city.cityCode
                smartObj.county = city.county
                smartObj.countyCode = city.countyCode
                smartObj.province = city.province
                smartObj.provinceCode = city.provinceCode

                address = address.replace(city.matchValue, '')
                address = address.replace('市', '');
            }
        }

    }


    if (!smartObj.province) {
        let realname = '';
        realname = checkRealname(address);
        if (realname) {
            smartObj.name = realname;
        } else {
            var nameRegNew = /^[\u4E00-\u9FA5]{2,4}$/
            if (nameRegNew.test(address)) {
                smartObj.bakname = address;
            }
        }

    }
    if (nums === 1) {
        smartObj.residueaddress = address;
    } else {
        smartObj.residueaddress = '';
    }

    return smartObj;
}
////过滤特殊字符
function stripscript(address) {

    //去除空格...
    address = address.replace(/\r\n/g, ' ').replace(/\n/g, ' ').replace(/\t/g, ' ');
    address = address.replace(/\s+/g, " ");

    //去除 非3个字节
    //address = address.replace(/[^\u0800-\uffff]/g,'');

    //自定义去除关键字，可自行添加
    const search = ['​手机号码', '​所​在地区', '详细​地址', '地址', '收货地址', '收​货​人', '收货人', '收件人', '收货', '邮编', '电话', '寄件人', '收', '姓名', '：', ':', '；', ';', '，', ',', '。', '、', '…'];
    search.forEach(str => {
        address = address.replace(new RegExp(str, 'g'), ' ')
    });

    //多个空格replace为一个
    address = address.replace(/ {2,}/g, ' ');
    //整理电话格式
    address = address.replace(/(\d{3})-(\d{4})-(\d{4})/g, '$1$2$3');
    address = address.replace(/(\d{3}) (\d{4}) (\d{4})/g, '$1$2$3');

    return address;

}

//验证姓氏
function checkSurname(name, color) {
    if (color === '色') {
        return false;
    }

    //js正则表达式  match
    //为什么此时的match方法不对
    if ("赵|钱|孙|李|周|吴|郑|王|冯|陈|褚|卫|蒋|沈|韩|杨|朱|秦|尤|许|何|吕|施|张|孔|曹|严|华|金|魏|陶|姜|戚|谢|邹|喻|柏|水|窦|章|云|苏|潘|葛|奚|范|彭|郎|鲁|韦|昌|马|苗|凤|花|方|俞|任|袁|柳|酆|鲍|史|唐|费|廉|岑|薛|雷|贺|倪|汤|滕|殷|罗|毕|郝|邬|安|常|乐|于|时|傅|皮|卞|齐|康|伍|余|元|卜|顾|孟|平|黄|和|穆|萧|尹|姚|邵|湛|汪|祁|毛|禹|狄|米|贝|明|臧|计|伏|成|戴|谈|宋|茅|庞|熊|纪|舒|屈|项|祝|董|梁|杜|阮|蓝|闵|席|季|麻|强|贾|路|娄|危|江|童|颜|郭|梅|盛|林|刁|锺|徐|邱|骆|高|夏|蔡|田|樊|胡|凌|霍|虞|万|支|柯|昝|管|卢|莫|经|房|裘|缪|干|解|应|宗|丁|宣|贲|邓|郁|单|杭|洪|包|诸|左|石|崔|吉|钮|龚|程|嵇|邢|滑|裴|陆|荣|翁|荀|羊|於|惠|甄|麴|家|封|芮|羿|储|靳|汲|邴|糜|松|井|段|富|巫|乌|焦|巴|弓|牧|隗|山|谷|车|侯|宓|蓬|全|郗|班|仰|秋|仲|伊|宫|宁|仇|栾|暴|甘|钭|历|戎|祖|武|符|刘|景|詹|束|龙|叶|幸|司|韶|郜|黎|蓟|溥|印|宿|白|怀|蒲|邰|从|鄂|索|咸|籍|赖|卓|蔺|屠|蒙|池|乔|阳|郁|胥|能|苍|双|闻|莘|党|翟|谭|贡|劳|逄|姬|申|扶|堵|冉|宰|郦|雍|却|璩|桑|桂|濮|牛|寿|通|边|扈|燕|冀|僪|浦|尚|农|温|别|庄|晏|柴|瞿|阎|充|慕|连|茹|习|宦|艾|鱼|容|向|古|易|慎|戈|廖|庾|终|暨|居|衡|步|都|耿|满|弘|匡|国|文|寇|广|禄|阙|东|欧|殳|沃|利|蔚|越|夔|隆|师|巩|厍|聂|晁|勾|敖|融|冷|訾|辛|阚|那|简|饶|空|曾|毋|沙|乜|养|鞠|须|丰|巢|关|蒯|相|查|后|荆|红|游|竺|权|逮|盍|益|桓|公|万俟|司马|上官|欧阳|夏侯|诸葛|闻人|东方|赫连|皇甫|尉迟|公羊|澹台|公冶|宗政|濮阳|淳于|单于|太叔|申屠|公孙|仲孙|轩辕|令狐|钟离|宇文|长孙|慕容|司徒|司空|召|有|舜|叶赫那拉|丛|岳|寸|贰|皇|侨|彤|竭|端|赫|实|甫|集|象|翠|狂|辟|典|良|函|芒|苦|其|京|中|夕|之|章佳|那拉|冠|宾|香|果|依尔根觉罗|依尔觉罗|萨嘛喇|赫舍里|额尔德特|萨克达|钮祜禄|他塔喇|喜塔腊|讷殷富察|叶赫那兰|库雅喇|瓜尔佳|舒穆禄|爱新觉罗|索绰络|纳喇|乌雅|范姜|碧鲁|张廖|张简|图门|太史|公叔|乌孙|完颜|马佳|佟佳|富察|费莫|蹇|称|诺|来|多|繁|戊|朴|回|毓|税|荤|靖|绪|愈|硕|牢|买|但|巧|枚|撒|泰|秘|亥|绍|以|壬|森|斋|释|奕|姒|朋|求|羽|用|占|真|穰|翦|闾|漆|贵|代|贯|旁|崇|栋|告|休|褒|谏|锐|皋|闳|在|歧|禾|示|是|委|钊|频|嬴|呼|大|威|昂|律|冒|保|系|抄|定|化|莱|校|么|抗|祢|綦|悟|宏|功|庚|务|敏|捷|拱|兆|丑|丙|畅|苟|随|类|卯|俟|友|答|乙|允|甲|留|尾|佼|玄|乘|裔|延|植|环|矫|赛|昔|侍|度|旷|遇|偶|前|由|咎|塞|敛|受|泷|袭|衅|叔|圣|御|夫|仆|镇|藩|邸|府|掌|首|员|焉|戏|可|智|尔|凭|悉|进|笃|厚|仁|业|肇|资|合|仍|九|衷|哀|刑|俎|仵|圭|夷|徭|蛮|汗|孛|乾|帖|罕|洛|淦|洋|邶|郸|郯|邗|邛|剑|虢|隋|蒿|茆|菅|苌|树|桐|锁|钟|机|盘|铎|斛|玉|线|针|箕|庹|绳|磨|蒉|瓮|弭|刀|疏|牵|浑|恽|势|世|仝|同|蚁|止|戢|睢|冼|种|涂|肖|己|泣|潜|卷|脱|谬|蹉|赧|浮|顿|说|次|错|念|夙|斯|完|丹|表|聊|源|姓|吾|寻|展|出|不|户|闭|才|无|书|学|愚|本|性|雪|霜|烟|寒|少|字|桥|板|斐|独|千|诗|嘉|扬|善|揭|祈|析|赤|紫|青|柔|刚|奇|拜|佛|陀|弥|阿|素|长|僧|隐|仙|隽|宇|祭|酒|淡|塔|琦|闪|始|星|南|天|接|波|碧|速|禚|腾|潮|镜|似|澄|潭|謇|纵|渠|奈|风|春|濯|沐|茂|英|兰|檀|藤|枝|检|生|折|登|驹|骑|貊|虎|肥|鹿|雀|野|禽|飞|节|宜|鲜|粟|栗|豆|帛|官|布|衣|藏|宝|钞|银|门|盈|庆|喜|及|普|建|营|巨|望|希|道|载|声|漫|犁|力|贸|勤|革|改|兴|亓|睦|修|信|闽|北|守|坚|勇|汉|练|尉|士|旅|五|令|将|旗|军|行|奉|敬|恭|仪|母|堂|丘|义|礼|慈|孝|理|伦|卿|问|永|辉|位|让|尧|依|犹|介|承|市|所|苑|杞|剧|第|零|谌|招|续|达|忻|六|鄞|战|迟|候|宛|励|粘|萨|邝|覃|辜|初|楼|城|区|局|台|原|考|妫|纳|泉|老|清|德|卑|过|麦|曲|竹|百|福|言|第五|佟|爱|年|笪|谯|哈|墨|南宫|赏|伯|佴|佘|牟|商|西门|东门|左丘|梁丘|琴|后|况|亢|缑|帅|微生|羊舌|海|归|呼延|南门|东郭|百里|钦|鄢|汝|法|闫|楚|晋|谷梁|宰父|夹谷|拓跋|壤驷|乐正|漆雕|公西|巫马|端木|颛孙|子车|督|仉|司寇|亓官|鲜于|锺离|盖|逯|库|郏|逢|阴|薄|厉|稽|闾丘|公良|段干|开|光|操|瑞|眭|泥|运|摩|伟|铁|迮".search(name) != -1) {
        return true;
    } else {
        return false;
    }
}

function checkRealname(resultname) {

    var nameReg = /^[\u4E00-\u9FA5]{2,4}$/
    if (nameReg.test(resultname)) {
        if (resultname.indexOf("街") != -1 || resultname.indexOf("街道") != -1 || resultname.indexOf("区") != -1 || resultname.indexOf("县") != -1 || resultname.indexOf("镇") != -1 || resultname.indexOf("乡") != -1) {
            return false;
        }

        if (checkSurname(resultname.substr(0, 1), resultname.substr(1, 1))) {

            return resultname;
        }
    }
    /* if(resultname.indexOf("街") != -1 || resultname.indexOf("街道") != -1 || resultname.indexOf("区") != -1 || resultname.indexOf("县") != -1 || resultname.indexOf("镇") != -1 || resultname.indexOf("乡") != -1){
    		return false;
    }
	
    if (checkSurname(resultname.substr(0, 1),resultname.substr(1, 1))) {

    	return resultname;
    } */
}

function UnicodeToAscii(content) {

    //var code = content.match(/&#(\d+);/g);

    result = '';
    for (var i = 0; i < content.length; i++) {
        result += String.fromCharCode(content[i].replace(/[&#;]/g, ''));
    }

    return content;
}

function str2utf8(str) {
    return eval('\'' + encodeURI(str).replace(/%/gm, '\\x') + '\'');
}

export { smart };